import React from 'react';
import { message, Popconfirm } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import CheckIn from './components/Transfer/CheckIn';
import Detail from './components/Transfer/Detail';
import { projectTransfer, dicPayChannel } from '../../axios/dictionaries'
import { postFrom, config, transterQuery } from '../../axios';
import moment from 'moment';
import axios from 'axios';
import { moneyAddComma, handleExportParams } from '../../utils/index'

export default class Page extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false, //页面加载中
            params: {
                checkDate1: "",
                checkDate2: "",
                createDate1: "",
                createDate2: "",
                customerName: "",
                customerPhone: "",
                merchantName: "",
                payChannel: "",
                payDate1: "",
                payDate2: "",
                projectName: "",
                searialNubmer: "",
                status: "",
                pageSize: 10
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableTotalMny: 0,
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showCheckInModal: false, //显示登记
            showDetailModal: false, //显示详情
            inputSearchTerm: "170px",
        }
    }

    componentDidMount() {
        this.handleSearch()
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });


        axios.all([
            postFrom({ url: config.API_traderecordoffline_findPage, data }),
            postFrom({ url: config.API_traderecordoffline_getTotalMoney, data }),
        ]).then(axios.spread((listRes, CountRes) => {
            this.setState({ current: listRes.current, tableTotalMny: CountRes, tableTotal: listRes.total, tableData: listRes.records, tableLoading: false })
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }

    handleShowCheckIn = (id) => { //显示登记
        const that=this;

        this.setState({ showCheckInModal: true },
            () =>{
            that.checkInRef.loadPackageClearAttachIds();
        });


    }

    handleShowDetail = (id) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(id);
    }

    handleCheck = (checkResult, id, referenceNumber) => { //检测是否已到账
        return postFrom({ url: config.API_traderecordoffline_check, data: { checkResult, id, referenceNumber } }).then(res => {
            message.success('操作成功');
            this.handleSearch();
            return res
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
            return err
        })
    }
    handleReceive = (id) => {
        this.setState({ showDetailModal: true });
        this.detailRef.openReceived(id, (referenceNumber => {
            this.handleCheck(true, id, referenceNumber).then((res) => {
                if (res === 0) {
                    this.setState({ showDetailModal: false });
                }
            })
            
        }))
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showCheckInModal,
            showDetailModal,
            inputSearchTerm,
            tableTotalMny,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <SuperForm
                    data={searchData(inputSearchTerm)}
                    sumbit={this.handleSearch}
                    addParams={'current'}
                />
                <div className="search-btn-list template-style">
                    <AuthButton authkey="f-2-6" type="primary" onClick={this.handleShowCheckIn} icon="swap-right">转账登记</AuthButton>
                    <span style={{ marginLeft: '8px' }} />
                    <AuthButton authkey="f-2-3" type="primary" icon="export" href={`${config.API_traderecordoffline_transferRecordExprot}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                        导出
                    </AuthButton>
                </div>
                <TableDOM
                    columns={columns({ handleCheck: this.handleCheck, handleShowDetail: this.handleShowDetail, handleReceive: this.handleReceive })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    onChange={this.handleSearch}
                />
                <CheckIn
                    onRef={ref => this.checkInRef = ref}
                    visible={showCheckInModal}
                    handleCancel={() => { this.setState({ showCheckInModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />
            </PageWrap>
        )
    }


}

const searchData = (inputSearchTerm) => {
    let data = [
        {
            tagName: 'Input',
            formConfig: { name: 'merchantName' },
            attribute: { placeholder: '输入商户简称', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectName' },
            attribute: { placeholder: '输入项目', style: { width: inputSearchTerm } }
        },
        // {
        //     tagName: 'Input',
        //     formConfig: { name: 'buildingName' },
        //     attribute: { placeholder: '输入楼栋', style: { width: inputSearchTerm } }
        // },
        // {
        //     tagName: 'Input',
        //     formConfig: { name: 'roomNo' },
        //     attribute: { placeholder: '输入房号', style: { width: inputSearchTerm } }
        // },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'createDate1' },
            attribute: { placeholder: '请选择登记开始日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'createDate2' },
            attribute: { placeholder: '请选择登记结束日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'payDate1' },
            attribute: { placeholder: '请选择交易开始日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'payDate2' },
            attribute: { placeholder: '请选择交易结束日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'checkDate1' },
            attribute: { placeholder: '请选择审核开始日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'checkDate2' },
            attribute: { placeholder: '请选择审核结束日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'searialNubmer' },
            attribute: { placeholder: '输入入账渠道', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Select',
            formConfig: { name: 'payChannel' },
            attribute: { placeholder: '请选择交易渠道', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(dicPayChannel), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'Input',
            formConfig: { name: 'customerName' },
            attribute: { placeholder: '输入租客', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'customerPhone' },
            attribute: { placeholder: '输入手机号码', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Select',
            formConfig: { name: 'status' },
            attribute: { placeholder: '请选择审核状态', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(projectTransfer), //.concat(dicHouseStatus)
            notResult: '',
        },
    ]
    handleExportParams().merchantId && data.splice(0, 1);
    return data;
};
const columns = ({ handleCheck, handleShowDetail, handleReceive }) => [
    {
        title: '登记日期 | 人员',
        dataIndex: 'createTime',

        render(text, record, index) {
            return <span>
                <div>{record.createTime ? moment(record.createTime).format('YYYY-MM-DD') : null}</div>
                {
                    record.merchantUserName ?
                        <React.Fragment>
                            <div style={{ color: "#009BFF" }}>{record.merchantUserName ? record.merchantUserName : null}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }
    },
    {
        title: '入账渠道',
        dataIndex: 'searialNumber',

    },
    {
        title: '交易参考号',
        dataIndex: 'referenceNumber',
    },
    {
        title: '交易日期',
        dataIndex: 'payDate',

        render(text, record, index) {
            return <span>
                <div>{record.payDate ? moment(record.payDate).format('YYYY-MM-DD') : null}</div>
            </span>
        }
    },
    {
        title: '交易金额（元）',
        dataIndex: 'amount',
        align: 'right',
        render(text, record, index) {
            return <span>
                <div>{record.amount ? moneyAddComma(record.amount) : null}</div>
            </span>
        }
    },
    {
        title: '交易渠道',
        dataIndex: 'payChannel',

        render(text, record, index) {
            let now = dicPayChannel.find(item => item.value === text);
            if (now)
                return <span>
                    <div>{now.title}</div>
                </span>
            return null
        }
    },
    {
        title: '租客',
        dataIndex: 'customerId',

        render(text, record, index) {
            return <span>
                <div>{record.customerName ? record.customerName : null}</div>
                {record.customerPhone ?
                    <React.Fragment>
                        <div>
                            {record.customerPhone ? record.customerPhone : null}
                        </div>
                    </React.Fragment>
                    : null}
            </span>
        }
    },
    {
        title: '审核状态 | 日期',
        dataIndex: 'status',

        render(text, record, index) {
            let now = projectTransfer.find(item => item.value === text);
            return <span>
                <div>{now ? <span style={{color:now.color}}>{now.title} </span>: null}</div>
                {record.checkTime ?
                    <React.Fragment>
                        <div>
                            {record.checkTime ? moment(record.checkTime).format('YYYY-MM-DD') : null}
                        </div>
                    </React.Fragment>
                    : null
                }

            </span>
        }
    },
    {
        title: '商户 | 项目',
        dataIndex: 'mustPhayDdate1',

        render(text, record, index) {
            return <span>
                <div>{record.merchantShortName ? record.merchantShortName : null}</div>
                {
                    record.projectName ?
                        <React.Fragment>
                            <div>{record.projectName ? record.projectName : null}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div className="table-action">
                <AuthButton authkey="f-2-2"><span className="showClickDetail" onClick={() => { handleShowDetail(record.id) }}>详情</span></AuthButton>
                {
                    record.status === 1  && 
                    <React.Fragment>
                        <AuthButton authkey="f-2-4">
                            <span className="showClickDetail" onClick={() => handleReceive(record.id)}>确认到账</span>
                        </AuthButton>
                        <AuthButton authkey="f-2-5">
                            <Popconfirm placement="top" title={"确定未到账吗？"} onConfirm={() => { handleCheck(false, record.id) }} okText="确定" cancelText="不了">
                                <span className="showClickDetail">未到账</span>
                            </Popconfirm>
                        </AuthButton>
                    </React.Fragment>
                }
            </div>)
        }
    }
];



// WEBPACK FOOTER //
// ./src/page/Payment/Transfer.js